import { formatString } from "@/lib/formatString";

export function ZeroDaysHero({ blok }) {
    return <div style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundRepeat: "repeat", // Prevent repeating the background
    }}
        className="max-w-7xl w-full text-center lg:text-left px-4"
    >
        <div className="flex pt-32 gap-10 lg:gap-28 items-center flex-col xl:flex-row w-full " >
            <div className="flex-2">
                <h1 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] font-bold font-aileron text-center lg:text-left">
                    {formatString(blok.heading)}
                </h1>
                <p className="text-[18px] m-auto lg:w-full lg:text-[32px] font-normal mt-[16px] md:mt-auto px-4 xl:px-0">
                    <span className="font-bold">{formatString(blok.lead)}</span> - {formatString(blok.subheading)}
                </p>
            </div>
            <div className="flex-1 lg:mt-10">
                <img src={blok?.image?.filename} className="h-[382px] w-[382px]" />
            </div>
        </div>
    </div>

}